export const ACCESS = {
  CREDIT_TRANSFER: "credit_transfer",
};

export function hasAccess(userAccess, requiredKey) {
  if (!Array.isArray(userAccess)) return false;
  return userAccess.includes(requiredKey);
}
